"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "content"
  }, [_c("iframe", {
    ref: "hunterIframe",
    staticClass: "template-portal",
    attrs: {
      src: _vm.uriPortal,
      allow: "clipboard-write; clipboard-read;",
      frameborder: "0"
    }
  })])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;